import { PropsWithChildren } from 'react';

export function Container({ children, isScrollable }: PropsWithChildren<{ isScrollable: boolean }>) {
  return (
    <div className={`flex flex-col p-6 gap-4 w-full h-full ${isScrollable ? 'overflow-y-auto' : 'overflow-hidden'}`}>
      {children}
    </div>
  );
}
